export enum DefinitionTarget {
  Customer = 1,
  Product = 2,
  Location = 4,
}
